module.exports = __webpack_public_path__ + "static/img/Report3DImg6.d26a11ea.png";